import React from 'react'
import {
    Switch,
    Route,
    Redirect,
} from 'react-router-dom'
import FrontApp from '../front/components/app'
import {
    forFeature,
    withRouter,
} from '../validator'
import Configurator from '../configurator'
import UnloggedRoute from './shared/unlogged-route'
import { LogoutRoute } from './shared/logout-route'
import { LoggedRoute } from './shared/logged-route'
import NotFoundRoute from './shared/not-found-route'
import FacebookFriends from '../front/components/community/facebook-friends'

const EventAttendanceForm = React.lazy(() => import('../front/components/events/detail/parts/attendance-form/container'))
const EventDetail = React.lazy(() => import('../front/components/events/detail/container'))
const CheersContainer = React.lazy(() => import('../front/components/shared/cheers/container'))
const FamilyContainer = React.lazy(() => import('../front/components/shared/family/container'))
const GroupDetail = React.lazy(() => import('../front/components/groups/detail/container'))
const GroupsFrontList = React.lazy(() => import('../front/components/groups/list/container'))
const SportFacilities = React.lazy(() => import('../front/components/sportvenues/list/container'))
const SportFacilityDetail = React.lazy(() => import('../front/components/sportvenues/detail'))
const SportFacilityDetailContacts = React.lazy(() => import('../front/components/sportvenues/detail/contacts'))
const SportFacilityDetailEvents = React.lazy(() => import('../front/components/sportvenues/detail/events'))
const SportnectionsContainer = React.lazy(() => import('../front/components/sportnections/container'))
const TimelineContainer = React.lazy(() => import('../front/components/timeline/container'))
const Community = React.lazy(() => import('../front/components/community'))
const MutualGroups = React.lazy(() => import('../front/components/community/mutual-groups'))
const MutualCheeringGroups = React.lazy(() => import('../front/components/community/mutual-cheering-groups'))
const MutualAttendedEvents = React.lazy(() => import('../front/components/community/mutual-attended-events'))
const MutualCheeringEvents = React.lazy(() => import('../front/components/community/mutual-cheering-events'))
const ContactsKnownUser = React.lazy(() => import('../front/components/community/contacts-known-user'))
const MySportnections = React.lazy(() => import('../front/components/community/my-sportnections'))
const SecretProfileContainer = React.lazy(() => import('../front/components/users/new-testing-container'))
const ProfileContainer = React.lazy(() => import('../front/components/users/container'))
const FaqContainer = React.lazy(() => import('../front/components/faq/container'))
const EventsFrontList = React.lazy(() => import('../front/components/events/list/container'))

const News = React.lazy(() => import('../components/news'))
const NewsDetail = React.lazy(() => import('../components/news/detail'))
const Landing = React.lazy(() => import('../components/landing/landing-sportnect/index'))
const Entities = React.lazy(() => import('../front/components/entities'))
const LoginSignpost = React.lazy(() => import('../components/auth/login-signpost'))
const LoginForms = React.lazy(() => import('../components/auth/login-forms'))
const SignupForms = React.lazy(() => import('../components/auth/signup-forms'))
const ForgottenPasswordForms = React.lazy(() => import('../components/auth/forgotten-password-forms'))
const OnBoarding = React.lazy(() => import('../components/on-boarding'))
const CognitoCallback = React.lazy(() => import('../components/auth/cognito-callback'))
const EmailUpdateCallback = React.lazy(() => import('../components/auth/email-update-callback'))
const UploadPhotoWebview = React.lazy(() => import('../front/components/photos/upload-photo-webview'))
const Messenger = React.lazy(() => import('../components/messenger'))
const SFNLanding = React.lazy(() => import('../components/sfn/landing'))
const SFNUpdateProfile = React.lazy(() => import('../components/sfn/update-profile'))
const SFNPayment = React.lazy(() => import('../components/sfn/payment'))

const GroupsSignpost = React.lazy(() => import('../front/components/signpost/groups'))
const EventsSignpost = React.lazy(() => import('../front/components/signpost/events'))
const ForChildrenSignpost = React.lazy(() => import('../front/components/signpost/for-children'))
const Organizers = React.lazy(() => import('../components/landing/landing-cities/organizers'))
const TakeInfo = React.lazy(() => import('../components/landing/landing-cities/take-info'))
const ForAthletesSignpost = React.lazy(() => import('../front/components/signpost/want-sport'))

const SharedSportsWebview = React.lazy(() => import('../front/components/sportnections/shared-sports-webview'))
const SportProfileContainer = React.lazy(() => import('../front/components/sport-profile/index'))
const SportProfileRowForm = React.lazy(() => import('../front/components/sport-profile/parts/sportprofile-row-form.jsx'))

@forFeature('SPORTNECT_ROUTES')
@withRouter()
export default class FrontRoutes extends Configurator {
    render = () => (
        <React.Suspense fallback={<span />}>
            <Switch>
                <LoggedRoute exact path={['/timeline', '/timeline-events', '/timeline-groups']}
                    render={() =>
                        <FrontApp
                            whitelistedFilterRoute
                            footerClass="d-none"
                        >
                            <TimelineContainer profileTimeline {...this.props} />
                        </FrontApp>
                    }
                />
                <Route exact path={'/new-profile/:userSlug'} render={() => <FrontApp><SecretProfileContainer {...this.props} /></FrontApp>} />
                <Route exact path={'/new-profile/:userSlug/photos'} render={() => <FrontApp><SecretProfileContainer activeTab="photos" {...this.props} /></FrontApp>} />
                <Route exact path={['/', '/users/:userSlug']} render={() => <FrontApp><ProfileContainer {...this.props} /></FrontApp>} />
                <Route exact path={'/users/:userSlug/photos'} render={() => <FrontApp><ProfileContainer subpage="photos" {...this.props} /></FrontApp>} />

                <Route exact path={'/sportprofile/:userSlug/:userSportId'} render={() => <FrontApp><SportProfileContainer {...this.props} /></FrontApp>} />
                <Route exact path={'/sportprofile/edit/:roleType/:userSportId/:meta'} render={() => <FrontApp><SportProfileRowForm {...this.props} /></FrontApp>} />

                <UnloggedRoute exact path={this.config.signpostLoginRoute} render={() => <LoginSignpost {...this.props} />} />
                <UnloggedRoute exact path={this.config.loginRoute} render={() => <LoginForms {...this.props} />} />
                <UnloggedRoute exact path={this.config.signupRoute} render={() => <SignupForms {...this.props} />} />
                <LogoutRoute exact path={this.config.forgottenPasswordRoute} render={() => <ForgottenPasswordForms {...this.props} />} />

                <UnloggedRoute exact path={'/login'} render={() => <FrontApp><Landing {...this.props} /></FrontApp>} />

                <Route exact path={'/cognito/oauth/callback'} render={() => <CognitoCallback {...this.props} />} />

                <LogoutRoute exact path={'/email/update/confirm'} render={() => <EmailUpdateCallback {...this.props} />} />

                <Route
                    exact
                    path={'/events'}
                    render={() => (
                        <FrontApp whitelistedFilterRoute footerClass="d-none">
                            <EventsFrontList
                                {...this.props}
                            />
                        </FrontApp>
                    )}
                />
                <Route
                    exact
                    path={'/camps'}
                    render={() => (
                        <FrontApp whitelistedFilterRoute footerClass="d-none">
                            <EventsFrontList
                                {...this.props}
                                defaultSearch={{
                                    'type': ['8'],
                                }}
                            />
                        </FrontApp>
                    )}
                />
                <Route exact path={'/events/:eventSlug'} render={() => <FrontApp><EventDetail {...this.props} /></FrontApp>} />
                <LoggedRoute exact path={'/events/:slug/cheers'} render={() => <FrontApp><CheersContainer type="event" {...this.props} /></FrontApp>} />
                <LoggedRoute exact path={'/events/:slug/family'} render={() => <FrontApp><FamilyContainer type="event" {...this.props} /></FrontApp>} />
                <Route exact path={'/events/:eventSlug/photos'} render={() => <FrontApp><EventDetail subpage="photos" {...this.props} /></FrontApp>} />
                <Route exact path={'/events/:eventSlug/attendance-form'} render={() => <FrontApp><EventAttendanceForm {...this.props} /></FrontApp>} />
                <Route exact path={'/events/:eventSlug/:action'} render={() => <FrontApp><EventDetail {...this.props} /></FrontApp>} />
                <Route exact path={'/events/:eventSlug/:action/:type'} render={() => <FrontApp><EventDetail {...this.props} /></FrontApp>} />

                <Route
                    exact
                    path={'/clubs'}
                    render={() => (
                        <FrontApp whitelistedFilterRoute footerClass="d-none">
                            <GroupsFrontList
                                {...this.props}
                                defaultLoad={true}
                            />
                        </FrontApp>
                    )}
                />
                <Route exact path={'/clubs/:clubId'} render={() => <FrontApp><GroupDetail {...this.props} /></FrontApp>} />
                <LoggedRoute exact path={'/clubs/:slug/cheers'} render={() => <FrontApp><CheersContainer type="group" {...this.props} /></FrontApp>} />
                <LoggedRoute exact path={'/clubs/:slug/family'} render={() => <FrontApp><FamilyContainer type="group" {...this.props} /></FrontApp>} />
                <Route exact path={'/clubs/:clubId/photos'} render={() => <FrontApp><GroupDetail subpage="photos" {...this.props} /></FrontApp>} />
                <Route exact path={'/clubs/:clubId/:action'} render={() => <FrontApp><GroupDetail {...this.props} /></FrontApp>} />
                <Route exact path={'/clubs/:clubId/:action/:type'} render={() => <FrontApp><GroupDetail {...this.props} /></FrontApp>} />

                <Route
                    exact
                    path={'/sfn'}
                    render={() => (
                        <FrontApp
                            whitelistedFilterRoute
                            hideFooter
                            sfNetwork
                        >
                            <SFNLanding
                                {...this.props}
                            />
                        </FrontApp>
                    )}
                />

                <Route
                    exact
                    path={'/sfn/update-profile'}
                    render={() => (
                        <FrontApp
                            whitelistedFilterRoute
                            hideFooter
                            sfNetwork
                        >
                            <SFNUpdateProfile
                                {...this.props}
                            />
                        </FrontApp>
                    )}
                />

                <Route
                    exact
                    path={'/sfn/payment'}
                    render={() => (
                        <FrontApp
                            whitelistedFilterRoute
                            hideFooter
                            sfNetwork
                        >
                            <SFNPayment
                                {...this.props}
                            />
                        </FrontApp>
                    )}
                />

                <Route
                    exact
                    path={'/sfn/users/:userSlug'}
                    render={() => (
                        <FrontApp
                            whitelistedFilterRoute
                            hideFooter
                            sfNetwork
                        >
                            <ProfileContainer {...this.props} />
                        </FrontApp>
                    )}
                />

                <Route
                    exact
                    path={'/sport-venues'}
                    render={() => (
                        <FrontApp whitelistedFilterRoute footerClass="d-none">
                            <SportFacilities
                                {...this.props}
                                defaultLoad={true}
                            />
                        </FrontApp>
                    )}
                />
                <Route exact path={'/sport-venues/:sportVenueSlug'} render={() => <FrontApp><SportFacilityDetail {...this.props} /></FrontApp>} />
                <Route exact path={'/sport-venues/:sportVenueSlug/contacts'} render={() => <FrontApp><SportFacilityDetailContacts {...this.props} /></FrontApp>} />
                <Route exact path={'/sport-venues/:sportVenueSlug/events'} render={() => <FrontApp><SportFacilityDetailEvents {...this.props} /></FrontApp>} />

                <LoggedRoute exact path={'/sportnections'} render={() => <FrontApp whitelistedFilterRoute><SportnectionsContainer {...this.props} /></FrontApp>} />
                <LoggedRoute exact path={'/community'} render={() => <FrontApp whitelistedFilterRoute><Community {...this.props} /></FrontApp>} />
                <LoggedRoute exact path={'/community/mutual-groups'} render={() => <FrontApp whitelistedFilterRoute><MutualGroups {...this.props} /></FrontApp>} />
                <LoggedRoute exact path={'/community/mutual-cheering-groups'} render={() => <FrontApp whitelistedFilterRoute><MutualCheeringGroups {...this.props} /></FrontApp>} />
                <LoggedRoute exact path={'/community/mutual-attended-events'} render={() => <FrontApp whitelistedFilterRoute><MutualAttendedEvents {...this.props} /></FrontApp>} />
                <LoggedRoute exact path={'/community/mutual-cheering-events'} render={() => <FrontApp whitelistedFilterRoute><MutualCheeringEvents {...this.props} /></FrontApp>} />
                <LoggedRoute exact path={'/community/contacts-known-user'} render={() => <FrontApp whitelistedFilterRoute><ContactsKnownUser {...this.props} /></FrontApp>} />
                <LoggedRoute exact path={'/community/facebook-friends'} render={() => <FrontApp whitelistedFilterRoute><FacebookFriends {...this.props} /></FrontApp>} />
                <LoggedRoute exact path={'/community/sportnections'} render={() => <FrontApp whitelistedFilterRoute><MySportnections {...this.props} /></FrontApp>} />

                <LoggedRoute exact path={'/sportnections'} render={() => <FrontApp whitelistedFilterRoute><SportnectionsContainer {...this.props} /></FrontApp>} />

                <Route exact path={'/faq'} render={() => <FrontApp><FaqContainer {...this.props} /></FrontApp>} />

                <Route exact path={'/on-boarding'} render={() => <FrontApp><OnBoarding /></FrontApp>} />
                <Route exact path={'/upload-photo'} render={() => <FrontApp><UploadPhotoWebview /></FrontApp>} />

                <Route exact path={'/shared-sports/:friendshipId'} render={() => <FrontApp><SharedSportsWebview {...this.props} /></FrontApp>} />


                {/** @TODO - make component more smart and remove this redirects */}
                <Redirect exact from={'/aktuality'} to={'/news'} />
                <Redirect exact from={'/aktuality/:actuality'} to={'/news/:actuality'} />

                <Route exact path={'/news'} render={() => <FrontApp><News {...this.props} /></FrontApp>} />
                <Route exact path={'/news/:actuality'} render={() => <FrontApp><NewsDetail hideTitle {...this.props} /></FrontApp>} />

                <Route exact path={`/${this.config.REACT_APP_TRANSLATION_ROUTES.entities}`} render={() => <FrontApp><Entities {...this.props} /></FrontApp>} />

                <Redirect exact from={'/messages'} to={'/chat'} />
                <Redirect exact from={'/messages/t/:threadSlug'} to={'/chat/t/:threadSlug'} />

                <LoggedRoute exact path={'/chat'} render={() => <FrontApp showNavAndFooter={true} footerClass="footer--chat"><Messenger {...this.props} /></FrontApp>} />
                <LoggedRoute exact path={'/chat/t/:threadSlug'} render={() => <FrontApp showNavAndFooter={true} footerClass="footer--chat"><Messenger {...this.props} /></FrontApp>} />

                <Route exact path="/jsem-organizator" render={() => <FrontApp><Organizers {...this.props} /></FrontApp>} />
                <Route exact path="/chci-byt-informovan" render={() => <FrontApp><TakeInfo {...this.props} /></FrontApp>} />
                <Route exact path="/pro-sportujici" render={() => <FrontApp><ForAthletesSignpost {...this.props} /></FrontApp>} />

                <Route
                    exact
                    path="/pro-sportujici/udalosti"
                    render={() =>
                        <FrontApp>
                            <EventsSignpost
                                filters={['InterestsEventLinks', 'Date|dateButtons', 'Sport', 'Type', 'Me', 'CityPart', 'Gender', 'AthletesLevel']}
                                defaultTag="4"
                            />
                        </FrontApp>
                    }
                />
                <Route
                    exact
                    path="/pro-sportujici/kluby"
                    render={() =>
                        <FrontApp>
                            <GroupsSignpost
                                filters={['InterestsGroupLinks', 'Sport', 'Me', 'CityPart', 'Gender']}
                                defaultTag="forAthletes=true"
                            />
                        </FrontApp>
                    }
                />
                <Route
                    exact
                    path="/top-udalosti"
                    render={() =>
                        <FrontApp>
                            <EventsSignpost
                                filters={['Signpost', 'Date|dateButtons', 'Sport', 'Type', 'Me', 'CityPart']}
                                defaultTag="1"
                            />
                        </FrontApp>
                    }
                />
                <Route
                    exact
                    path="/top-udalosti/udalosti"
                    render={() =>
                        <FrontApp>
                            <EventsSignpost
                                filters={['InterestsEventLinks', 'Date|dateButtons', 'Sport', 'Type', 'Me', 'CityPart']}
                                defaultTag="1"
                            />
                        </FrontApp>
                    }
                />
                <Route exact path="/pro-deti" render={() => <FrontApp><ForChildrenSignpost {...this.props} /></FrontApp>} />
                <Route
                    exact
                    path="/pro-deti/udalosti"
                    render={() =>
                        <FrontApp>
                            <EventsSignpost
                                filters={['InterestsEventLinks', 'Date|dateButtons', 'Sport', 'Type', 'Me', 'CityPart', 'Age']}
                                defaultTag="2"
                            />
                        </FrontApp>
                    }
                />
                <Route
                    exact
                    path="/pro-deti/kluby"
                    render={() =>
                        <FrontApp>
                            <GroupsSignpost
                                filters={['InterestsGroupLinks', 'Sport', 'Me', 'CityPart', 'Age', 'Gender']}
                                defaultTag="forKids=true"
                            />
                        </FrontApp>
                    }
                />
                <Route
                    exact
                    path="/pro-divaky"
                    render={() =>
                        <FrontApp>
                            <EventsSignpost
                                filters={['Signpost', 'Date|dateButtons', 'Sport', 'Type', 'Me', 'CityPart']}
                                defaultTag="3"
                            />
                        </FrontApp>
                    }
                />
                <Route
                    exact
                    path="/pro-divaky/udalosti"
                    render={() =>
                        <FrontApp>
                            <EventsSignpost
                                filters={['InterestsEventLinks', 'Date|dateButtons', 'Sport', 'Type', 'Me', 'CityPart']}
                                defaultTag="3"
                            />
                        </FrontApp>
                    }
                />

                <NotFoundRoute routesType="frontRoutes" />
            </Switch>
        </React.Suspense>
    )
}
